import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    if (typeof window.newrelic === "object") {
      window.newrelic.setCustomAttribute("domain", window.location.hostname)
      window.newrelic.setCustomAttribute("pageType", document.body.dataset.pageType)
    }
  }
}
